/**
 * gost-summary コンポーネント専用i18n定数
 */

export const GOST_SUMMARY_I18N = {
  // パンくずリスト
  breadcrumb: {
    userList: $localize`:@@home.gostSummary.breadcrumb.userList:ユーザー一覧`,
    gostSummary: $localize`:@@home.gostSummary.breadcrumb.gostSummary:GOSTレポート`,
  },
} as const;

export type GostSummaryI18n = typeof GOST_SUMMARY_I18N;
